// Public SMS Alerts disclosure for LGV's transactional Auction notifications.
// Provides the stable consent-page URL used by the Auction registration form
// and Twilio verification. It does not enable SMS sending by itself.

import React from "react";
import { Link } from "react-router-dom";
import SeoHead from "../../components/seo_head";

export default function SmsAlerts() {
  return <section id="top-content" className="container-fluid py-5">
    <SeoHead title="SMS Alerts Terms | Let's Go Vote" description="Terms for optional Let's Go Vote transactional Auction SMS alerts." path="/sms-alerts" breadcrumbs={[{ name: "Home", path: "/" }, { name: "SMS Alerts", path: "/sms-alerts" }]} />
    <div className="container"><div className="white-section p-4 rounded shadow-sm bg-white text-start">
      <h1 className="display-5 mb-3">SMS Alerts Terms</h1>
      <p>Let&apos;s Go Vote Auction SMS alerts are optional and available only to U.S. phone numbers when enabled for an event.</p>
      <h2 className="h4 mt-4">What you can receive</h2>
      <p>With your separate consent, LGV may send transactional alerts when you are outbid, win an item, payment is received, or an item is ready for pickup. Message frequency varies with your Auction activity. Marketing messages are not included in this consent.</p>
      <h2 className="h4 mt-4">Your choices</h2>
      <p>Consent is not a condition of purchase. Message and data rates may apply. Reply STOP to stop future LGV SMS alerts. Reply HELP for help or visit the <Link to="/help">Help Center</Link> and <Link to="/contact">Contact Support</Link>.</p>
      <h2 className="h4 mt-4">Privacy</h2>
      <p>LGV does not sell, rent, or share SMS opt-in consent with third parties. See our <Link to="/privacy">Privacy Policy</Link> and <Link to="/terms">Terms &amp; Conditions</Link>.</p>
      <p className="mt-5 small text-muted">Last Updated: October 29, 2026. This implementation copy requires legal review before production SMS launch.</p>
    </div></div>
  </section>;
}
